import React from 'react'

function TenderTextDDVG() {
  return (
    <embed src="\pdfs\EAT1.1.6.4_DD-VG_Variable_twist_outlet_with_jet_straightener_2018_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextDDVG